<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">设置</span>
    </h2>
    <breadcrumb firstName="门店管理"></breadcrumb>
    <el-card class="setting-shop-wrapper">
      <section class="audit-setting">
        <div class="title">药店审方模式</div>
        <controller label="线下审方" v-model="offlineMode" />
        <div class="tips">启用后，医生开具处方后即可下载打印处方笺，药师在线下签字审方</div>
      </section>
      <section class="channel-setting" v-if="form.channelAuditMode.length > 0">
        <div class="title">渠道独立设置审方模式</div>
        <div class="tips">支持三方渠道独立设定审方模式，不影响使用智云问诊产品开方的审方模式</div>
        <el-form :model="form" ref="ruleForm" label-position="left" label-width="80px" class="isPlatform_class">
          <template v-for="(item, index) in form.channelAuditMode">
            <div class="box" :key="index">
              <el-form-item :label="item.channelName">
                <el-radio-group v-model="item.isPlatform">
                  <el-radio :label="1">智云平台药师</el-radio>
                  <el-radio :label="2">线下审方</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </template>
        </el-form>
      </section>
      <section class="print-tmpl-setting">
        <div class="title">处方笺打印样式设置</div>
        <div class="setting-wrapper">
          <div v-if="forbiddenModifyTemplate" class="hint">
            *公司已配置统一的处方笺模板，无法手动更改，若有疑问请联系销售经理
          </div>
          <div class="example-list">
            <div class="example-item">
              <img src="@/assets/img/shopmanager/example-new.png" alt="" />
              <el-button type="text" @click="previewNew">预览</el-button>
            </div>
            <div class="example-item">
              <img src="@/assets/img/shopmanager/example-old.png" alt="" />
              <el-button type="text" @click="previewOld">预览</el-button>
            </div>
          </div>
          <el-radio-group :disabled="forbiddenModifyTemplate" class="print-radio" v-model="printMode">
            <el-radio v-for="item in printModeList" :key="item.value" :label="item.value">
              {{ item.label }}
              <el-tooltip
                v-if="item.value === 1"
                popper-class="shop-setting-tooltip"
                effect="dark"
                content="纸张建议A5（首选）或A4，自动适配打印机，正常无需调整。若发现出现打印不全等，请调整打印参数“适应打印区域”、“缩放比例90%”"
                placement="top"
              >
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-radio>
          </el-radio-group>
        </div>
      </section>
      <el-button class="submit" type="primary" @click="confirmSetting">保存</el-button>
    </el-card>
    <image-viewer
      :z-index="2000"
      :preview-index="0"
      :show="previewSrcList.length > 0 && showViewer"
      :on-close="() => (showViewer = false)"
      :url-list="previewSrcList"
    />
  </div>
</template>

<script>
import Fetch from '@/api';
import breadcrumb from '@/components/global/breadcrumb';
import controller from './components/controller.vue';
import ImageViewer from '@/components/Image/image-viewer.vue';

export default {
  name: 'settingShop',
  components: {
    ImageViewer,
    breadcrumb,
    controller
  },
  data() {
    return {
      originMode: {},
      offlineMode: 0,
      form: {
        channelAuditMode: []
      },
      printMode: 0,
      showViewer: false,
      previewSrcList: [],
      forbiddenModifyTemplate: false
    };
  },
  computed: {
    printModeList() {
      return [
        { label: '固定长宽比例，适配A4/A5纸', value: 1 },
        { label: '长宽不固定，根据内容适配高度', value: 0 }
      ];
    }
  },
  mounted() {
    const { prescriptionTemplate, forbiddenModifyTemplate } = this.$route.query;
    this.printMode = Number(prescriptionTemplate);
    this.forbiddenModifyTemplate = Boolean(Number(forbiddenModifyTemplate));
    this.getStoreAuditModeSetting();
  },
  methods: {
    getStoreAuditModeSetting() {
      const { storeId } = this.$route.params;
      Fetch.getStoreAuditModeSetting({ storeId }).then(({ offlineMode, channelAuditMode }) => {
        this.offlineMode = offlineMode;

        this.originMode = { offlineMode, channelAuditMode: JSON.parse(JSON.stringify(channelAuditMode)) };
        this.form.channelAuditMode = channelAuditMode;
      });
    },

    confirmSetting() {
      const { originMode, offlineMode, printMode } = this;
      this.$confirm('确认保存当前设置', '确认保存', {
        customClass: 'confirm',
        center: true,
        showClose: false
      })
        .then(() => {
          const { storeId } = this.$route.params;
          const { prescriptionTemplate } = this.$route.query;
          const data = { storeId, originMode, newMode: { offlineMode, channelAuditMode: this.form.channelAuditMode } };

          return Promise.allSettled([
            Fetch.updateStoreAuditModeSetting({
              ...data
            }),
            printMode !== Number(prescriptionTemplate) &&
              Fetch.updateStorePrescriptionTmpl({
                storeId,
                prescriptionTemplate: printMode
              })
          ]);
        })
        .then(result => {
          if (result[1].status === 'fulfilled') {
            this.$store.dispatch('permission/getInfo', { refresh: true });
          }

          if (result[0].status === 'fulfilled') {
            this.$message.success('保存成功');
            this.$router.push('/shopManagement');
          }
        });
    },
    previewNew() {
      this.previewSrcList = [
        require('@/assets/img/shopmanager/sample-west-new.png'),
        require('@/assets/img/shopmanager/sample-chinese-new.png')
      ];
      this.$nextTick(() => {
        this.showViewer = true;
      });
    },
    previewOld() {
      this.previewSrcList = [
        require('@/assets/img/shopmanager/sample-west-old.png'),
        require('@/assets/img/shopmanager/sample-chinese-old.png')
      ];
      this.$nextTick(() => {
        this.showViewer = true;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  display: flex;
}
.setting-shop-wrapper {
  .audit-setting {
    margin-bottom: 32px;
  }

  .channel-setting,
  .print-tmpl-setting {
    margin-bottom: 20px;
  }

  .title {
    margin-bottom: 12px;
    color: #242424;
    font-size: 18px;
    font-weight: bold;
  }

  .controller {
    display: flex;
    align-items: center;
    height: 40px;
    margin-bottom: 8px;

    /deep/.label {
      width: 80px;
      color: #707070;
      font-size: 14px;
    }

    /deep/.content {
      flex: 1;
      font-size: 14px;
    }

    /deep/.el-radio {
      color: #bdbdbd;
    }
  }
  .isPlatform_class {
    @extend .controller;
    display: block;
    height: auto;
  }

  .tips {
    margin-bottom: 12px;
    font-size: 12px;
    color: #707070;

    &:before {
      content: '*';
      color: #e0514c;
      font-size: 12px;
    }
  }

  .submit {
    margin-left: 80px;
    width: 174px;
  }

  .setting-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .example-list {
    display: flex;
    gap: 45px;
    width: 580px;

    .example-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 180px;

      img {
        height: 212px;
      }
    }
  }

  .print-radio {
    display: flex;
    gap: 45px;
    width: 600px;

    /deep/.el-radio {
      flex: 1;
      margin: 0;
    }
  }

  .hint {
    font-weight: 400;
    font-size: 12px;
    color: #ff4e47;
    line-height: 17px;
    text-align: left;
    font-style: normal;
  }
}
</style>

<style lang="less">
.shop-setting-tooltip {
  width: 300px;
}
</style>
